const USER_GENDER_VALUES = Object.freeze(['Male', 'Female', 'Another']);

export const GENDER_FORM_SELECT_OPTIONS = Object.freeze([
  { value: '', label: 'Select…' },
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Another', label: 'Another' },
]);

export function validateRequiredGender(raw) {
  const s = raw != null ? String(raw).trim() : '';
  if (!s) return 'Gender is required.';
  if (!USER_GENDER_VALUES.includes(s)) return 'Please select a valid gender option.';
  return '';
}

export function normalizeGenderForForm(raw) {
  const s = raw != null ? String(raw).trim() : '';
  return USER_GENDER_VALUES.includes(s) ? s : '';
}

export function getGenderDisplayLabel(raw) {
  const s = normalizeGenderForForm(raw);
  return s || '—';
}

/** Close Event Record roster bucket from stored gender. */
export function getParticipantGenderSummaryBucket(genderRaw) {
  const g = genderRaw != null ? String(genderRaw).trim().toLowerCase() : '';
  if (g === 'male') return 'male';
  if (g === 'female') return 'female';
  if (g === 'another') return 'another';
  return 'unspecified';
}

export function getParticipantGenderTableLabel(genderRaw) {
  const label = getGenderDisplayLabel(genderRaw);
  return label === '—' ? 'Not specified' : label;
}
